import React, { useRef } from 'react';
import classnames from 'classnames';
import { Input } from 'antd';
import { omit } from 'lodash';
import { useTranslation } from 'react-i18next';
import { getDirection } from '../../../../helpers';
import EmojiPickerPortal from '../EmojiPickerPortal';
import styles from './MyTextArea.module.scss';
const { TextArea } = Input;
const MyTextArea = ({ placeholderText, text, setText, containerClassName, forwardRef, textareaProps, 
/**
 * If true, emoji picker will be shown
 */
emojiPicker = false, }) => {
    const { t } = useTranslation();
    const inputRef = useRef(null);
    const textAreaRef = forwardRef || inputRef;
    const setSelectionRange = (start, end) => {
        var _a;
        (_a = textAreaRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea.textArea.setSelectionRange(start, end);
    };
    const handleEmojiInsert = (emoji) => {
        var _a, _b, _c;
        const selectionStart = ((_a = textAreaRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea.textArea.selectionStart) || 0;
        const selectionEnd = ((_b = textAreaRef.current) === null || _b === void 0 ? void 0 : _b.resizableTextArea.textArea.selectionEnd) || 0;
        const newText = `${text.slice(0, selectionStart)}${emoji}${text.slice(selectionEnd)}`;
        setText(newText);
        (_c = textAreaRef.current) === null || _c === void 0 ? void 0 : _c.focus();
        const newPos = selectionStart + emoji.length;
        setSelectionRange(newPos, newPos);
    };
    return (React.createElement("div", { className: classnames(styles.textbox, containerClassName, {
            [styles.disabled]: textareaProps === null || textareaProps === void 0 ? void 0 : textareaProps.disabled,
        }), onClick: () => {
            var _a;
            (_a = textAreaRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        } },
        React.createElement(TextArea, Object.assign({ dir: getDirection(), ref: textAreaRef, className: classnames(styles.textarea, textareaProps === null || textareaProps === void 0 ? void 0 : textareaProps.className), placeholder: t(`${placeholderText}`), onChange: (e) => {
                setSelectionRange(e.target.selectionStart, e.target.selectionEnd);
                setText(e.target.value);
            }, onClick: (e) => {
                const target = e.target;
                setSelectionRange(target.selectionStart, target.selectionEnd);
                if (textareaProps === null || textareaProps === void 0 ? void 0 : textareaProps.onClick) {
                    textareaProps.onClick(e);
                }
            }, onBlur: (e) => {
                if (textareaProps === null || textareaProps === void 0 ? void 0 : textareaProps.onBlur) {
                    textareaProps.onBlur(e);
                }
            }, onFocus: (e) => {
                setSelectionRange(e.target.selectionStart, e.target.selectionEnd);
                if (textareaProps === null || textareaProps === void 0 ? void 0 : textareaProps.onFocus) {
                    textareaProps.onFocus(e);
                }
            }, autoSize: { minRows: 5 }, value: text, bordered: false }, omit(textareaProps, 'onFocus', 'onBlur', 'onChange', 'onClick', 'className'))),
        emojiPicker && (React.createElement(EmojiPickerPortal, { disabled: textareaProps === null || textareaProps === void 0 ? void 0 : textareaProps.disabled, onEmojiSelect: handleEmojiInsert }))));
};
export default MyTextArea;
